export default __webpack_public_path__ + "static/media/megaphone.4fd90432.png";